import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import WhyChooseUs from './components/WhyChooseUs';
import CorePillars from './components/CorePillars';
import About from './components/About';
import Services from './components/Services';
import Solutions from './components/Solutions';
import CaseStudies from './components/CaseStudies';
import Insights from './components/Insights';
import Contact from './components/Contact';
import Footer from './components/Footer';
import StickyCTA from './components/StickyCTA';

function App() {
    return (
        <div className="App">
            <Navbar />
            <Hero />
            <WhyChooseUs />
            <CorePillars />
            <About />
            <Services />
            <Solutions />
            <CaseStudies />
            <Insights />
            <Contact />
            <Footer />
            <StickyCTA />
        </div>
    );
}

export default App;